import { requireStoreModule } from "$/lib/require-store-module"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

const searchSchema = z.object({
  tab: z.enum(["jobb", "fakturor"]).optional(),
})

export const Route = createFileRoute("/(app)/_auth/company-jobs/")({
  validateSearch: searchSchema,
  loader: async ({ context: { queryClient } }) => {
    await requireStoreModule(queryClient, "companiesEnabled")
    return {
      crumb: "alfred.pages.companyJobs.crumbs.companyJobs",
    }
  },
})
